module.exports = __webpack_public_path__ + "img/medicross-avatar.300cd6d4.jpeg";